import axios, { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';

import {
  DIAGNOSTIC_AUTHORIZATION_HEADER,
  DIAGNOSTIC_CUSTOM_HEADER,
} from 'src/ui/constants/environment';
import { copy } from 'src/ui/templates/copy';

interface CustomResponse extends AxiosResponse {
  responseTime: number;
}

export const diagnosticTest = async (): Promise<CustomResponse> => {
  const validationUrl = '/api/diagnostic';
  const requestStartedAt = Date.now();
  try {
    const response = await axios.get(validationUrl, {
      headers: {
        Authorization: DIAGNOSTIC_AUTHORIZATION_HEADER,
        'X-Custom-Header': DIAGNOSTIC_CUSTOM_HEADER,
      },
    });
    return {
      ...response,
      responseTime: Date.now() - requestStartedAt,
    };
  } catch {
    throw new Error(copy.errors.connectionFailed);
  }
};

/**
 * Diagnostic request to test authentication details.
 */
export const useDiagnostic = () => {
  return useQuery<CustomResponse, Error>('diagnostic', diagnosticTest, {
    cacheTime: 0, // disable cache so we don't use stale data
    retry: false,
  });
};

/**
 * Diagnostic request to test endpoint health details.
 */
export const useHealthCheck = () => {
  const alive = (endpoint: string) => {
    const url = endpoint.endsWith('/')
      ? `${endpoint}admin/alive`
      : `${endpoint}/admin/alive`;
    return axios.get(url);
  };

  return useMutation<AxiosResponse, Error, string>('diagnostic-health', alive);
};
